'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Input } from 'atoms/Input';
import { IFormInput } from './types';
import styles from './FormInput.module.css';

export const FormInput: FC<IFormInput> = ({
  id,
  field,
  isDirty,
  type = 'text',
  placeholder,
  hasError,
  maxLength,
  classes,
  iconClasses,
  autoComplete,
  isDisabled,
  inputRef,
  inputProps,
  ...rest
}) => {
  return (
    <Input
      id={id}
      error={hasError}
      type={type}
      placeholder={placeholder}
      inputProps={{ maxLength, ...inputProps }}
      classes={{
        ...classes,
        input: clsx(styles.input, classes?.input),
        error: styles.error,
      }}
      autoComplete={autoComplete}
      endAdornment={
        isDirty && (
          <Icon
            type={hasError ? IconType.close : IconType.tick}
            className={clsx(
              styles.icon,
              hasError
                ? styles.errorIcon
                : clsx(styles.successIcon, iconClasses?.success),
            )}
          />
        )
      }
      disabled={isDisabled}
      inputRef={inputRef}
      {...field}
      {...rest}
    />
  );
};
